import {ZodSchema} from 'zod'
import {zodToTs, printNode} from 'zod-to-ts'

export const fmtSchema = (schema: ZodSchema) => printNode(zodToTs(schema).node)
